import { documentsActionTypes } from "../constants";

const initialState = {
  loading: false,
  documents: [],
  totalDocumentsCount: null,
  document: null,
};

const documentsReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case documentsActionTypes.getDocuments.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case documentsActionTypes.getDocuments.SUCCESS:
      return {
        ...state,
        loading: false,
        documents: payload?.results || [],
        totalDocumentsCount: payload?.count || 0,
      };
    case documentsActionTypes.getDocuments.FAILURE:
      return {
        ...state,
        loading: false,
        documents: [],
        totalDocumentsCount: 0,
      };

    case documentsActionTypes.getDocument.REQUEST:
      return {
        ...state,
        loading: true,
        document: null,
      };
    case documentsActionTypes.getDocument.SUCCESS:
      return {
        ...state,
        loading: false,
        document: payload,
      };
    case documentsActionTypes.getDocument.FAILURE:
      return {
        ...state,
        loading: false,
        document: null,
      };

    default:
      return state;
  }
};

export default documentsReducers;
